export class ApiError extends Error {
  status: number
  constructor(message: string, status: number) {
    super(message)
    this.status = status
  }
}

export const AUTH_REQUIRED_EVENT = 'strategy-lab:auth-required'

export async function api<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...options,
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', ...(options?.headers || {}) },
  })
  if (!response.ok) {
    if (response.status === 401 && path !== '/api/auth/status') {
      window.dispatchEvent(new CustomEvent(AUTH_REQUIRED_EVENT))
    }
    let message = `Errore ${response.status}`
    try {
      const payload = await response.json()
      message = errorDetail(payload.detail) || message
    } catch { /* response without JSON */ }
    throw new ApiError(message, response.status)
  }
  // Some reverse proxies omit or rewrite Content-Type on otherwise valid API
  // responses.  Parse the body itself so the Lab does not reject valid JSON
  // solely because of that intermediary header.
  try {
    return await response.json() as T
  } catch {
    throw new ApiError('Il servizio ha restituito una risposta inattesa. Ricarica la pagina e riprova.', response.status)
  }
}

export const post = <T>(path: string, payload: unknown) =>
  api<T>(path, { method: 'POST', body: JSON.stringify(payload) })

export const patch = <T>(path: string, payload: unknown) =>
  api<T>(path, { method: 'PATCH', body: JSON.stringify(payload) })

function errorDetail(detail: unknown): string | undefined {
  if (typeof detail === 'string' && detail.trim()) return detail
  if (Array.isArray(detail)) {
    const messages = detail.map(item => {
      if (item && typeof item === 'object' && typeof (item as { msg?: unknown }).msg === 'string') return (item as { msg: string }).msg
      return undefined
    }).filter((item): item is string => Boolean(item))
    return messages.length ? messages.join(' · ') : 'Richiesta non valida'
  }
  if (detail && typeof detail === 'object') {
    const message = (detail as { message?: unknown }).message
    if (typeof message === 'string' && message.trim()) return message
    return 'Richiesta non valida'
  }
  return undefined
}
